import React from 'react';
import UserInfo from './components/UserInfo';

const UsersDetailView = () => <UserInfo />;

export default UsersDetailView;
